import { useTranslation } from 'react-i18next';
import IntroduceSection4Image1 from '../../assets/introduce_section4_image1.svg';
import IntroduceSection4Image1Cha from '../../assets/introduce_section4_image1_cha.svg';
import IntroduceSection4Image1Eng from '../../assets/introduce_section4_image1_eng.svg';
import IntroduceSection4ImageMobile from '../../assets/introduce_section4_image1_mobile.svg';
import IntroduceSection4ImageMobileCha from '../../assets/introduce_section4_image1_mobile_cha.svg';
import IntroduceSection4ImageMobileEng from '../../assets/introduce_section4_image1_mobile_eng.svg';
import { useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H2, H7, TitleNormalBold } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const IntroduceSection4 = () => {
  const { horizontal: padding } = useResponsivePadding();
  const { isMobile } = useDeviceType();
  const { t } = useTranslation();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{ background: '#14B446', paddingLeft: padding, paddingRight: padding }}>
      <BTBox height={isMobile ? 42 : `${pxToRem(81)}`} />
      <H7 style={{ color: 'white', opacity: 0.7 }}>Powering</H7>
      <BTBox height={isMobile ? 8 : `${pxToRem(40)}`} />
      <H2 style={{ color: 'white',
        ...(isMobile && (isEng || isChina)) ? {fontSize: '25px'} : {}
       }}>
        Powering innovation<br />across industries, globally.
      </H2>
      <BTBox height={`${pxToRem(40)}`} />
      <img src={isMobile ? (isEng ? IntroduceSection4ImageMobileEng : isChina ? IntroduceSection4ImageMobileCha : IntroduceSection4ImageMobile) : isEng ? IntroduceSection4Image1Eng : isChina ? IntroduceSection4Image1Cha : IntroduceSection4Image1} style={{ width: isMobile ? '100%' : '92%', height: 'auto' }} />
      <BTBox height={isMobile ? 15 : `${pxToRem(80)}`} />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
          gap: (isEng || isChina) ? '16px' : pxToRem(40),
          width: '100%',
        }}
      >
        {[
          {
            value: isEng ? '108' : isChina ? '7.7' : '1,400',
            unit: t('억원'),
            label: t('매출'),
            sub: t("24년 기준"),
          },
          {
            value: isEng ? '576,445' : isChina ? '53,554' : '16,200',
            unit: t('평'),
            label: t('공장 면적'),
            sub: t('25년 현재'),
          },
          {
            value: '1',
            unit: t('위'),
            label: t('삼성전자 훅업사평가'),
            sub: t("25년 상반기 기준"),
          },
          {
            value: '21',
            unit: t('년'),
            label: t('사업연수'),
            sub: t('25년 현재'),
          },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              width: '100%',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
              <TitleNormalBold fontSize={isMobile ? isEng ? '26px' : isChina ? '28px' :  '34px' : pxToRem(60)} color="white">
                {item.value}
              </TitleNormalBold>
              <TitleNormalBold fontSize={isEng ? isMobile ? '12px' : pxToRem(28) : (isChina && isMobile) ? '18px' : pxToRem(40)} color="white" style={{ marginBottom: isMobile ? '2px' : isEng ? '4px' : '8px' }}>
                {item.unit}
              </TitleNormalBold>
            </div>
            <BTBox height={pxToRem(15)} />
            <div style={{ width: '100%', height: '1px', backgroundColor: '#ffffffaa' }} />
            <BTBox height={pxToRem(15)} />
            <TitleNormalBold fontSize={isMobile ? isEng ? '10px' : isChina ? '11px' : '15px' : pxToRem(28)} color="white" style={{lineHeight: (isMobile && isEng) ? '13px' : pxToRem(37)}}>
              {item.label}
            </TitleNormalBold>
            <BTBox height={pxToRem(10)} />
            <TitleNormalBold fontSize={isMobile ? isEng ? '10px' : '11px' : pxToRem(20)} color="#ffffffaa">
              {item.sub}
            </TitleNormalBold>
          </div>
        ))}
      </div>
      <BTBox height={isMobile ? 71 : pxToRem(100)} />
    </VerticalLayout>
  );
};

export default IntroduceSection4;
